import { fetchUserCompanyFunctions, updateUserCompanyFunction } from '@/api/user.api';
import type { CompanyFunction, IUserCompanyFunction, IUserCompanyFunctionParams } from '@condo/domain';
import { groupBy } from 'lodash-es';
import type { ActionContext } from 'vuex';
import type { ICockpitStore } from '..';

export interface IUserCompanyFunctionStore {
    userCompanyFunctions: IUserCompanyFunction[];
    companyFunctionsByUser: Record<string, IUserCompanyFunction>;
    usersByCompanyFunctions: Partial<Record<CompanyFunction, string[]>>;
}

function getInitialState(): IUserCompanyFunctionStore {
    return {
        userCompanyFunctions: [],
        companyFunctionsByUser: {},
        usersByCompanyFunctions: {},
    };
}

const state = getInitialState();

const getters = {
    userCompanyFunctions(state: IUserCompanyFunctionStore): IUserCompanyFunction[] {
        return state.userCompanyFunctions;
    },
    companyFunctionsByUser(state: IUserCompanyFunctionStore): Record<string, IUserCompanyFunction> {
        return state.userCompanyFunctions.reduce((acc, cur) => {
            return {
                ...acc,
                [cur.userId]: cur,
            };
        }, {});
    },
    usersByCompanyFunctions(state: IUserCompanyFunctionStore): Partial<Record<CompanyFunction, IUserCompanyFunction[]>> {
        return groupBy(state.userCompanyFunctions, u => u.companyFunction);
    },
};

const actions = {
    async fetchUserCompanyFunctions({ commit }: ActionContext<IUserCompanyFunctionStore, ICockpitStore>) {
        const userCompanyFunctions = await fetchUserCompanyFunctions();
        commit('setUserCompanyFunctions', userCompanyFunctions);
    },
    async updateUserCompanyFunction({ commit }: ActionContext<IUserCompanyFunctionStore, ICockpitStore>, payload: IUserCompanyFunctionParams) {
        await updateUserCompanyFunction(payload);
    },
};

const mutations = {
    setUserCompanyFunctions(state: IUserCompanyFunctionStore, userCompanyFunctions: IUserCompanyFunction[]) {
        state.userCompanyFunctions = userCompanyFunctions;
    },
};

export const userCompanyFunctionStore = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
